<template>
    <vue-number-input
        :value="value"
        @change="onChange"
        :min="1"
        controls
        center
        size="small"/>
</template>

<script>
export default {
    name: 'AppSchedulerStepInput',
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    methods: {
        onChange(value) {
            if (Number.isNaN(value) || value < 1) {
                value = 1
            }
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>

</style>
